import { AssetsService } from "app/services/AssetsService";

const SI_IMAGES_DIRECTORY = "/images/sales-intelligence";
const SI_GIFS_DIRECTORY = `${SI_IMAGES_DIRECTORY}/gif`;

export const SISecondaryHomePageHeaderImageUrl = AssetsService.assetUrl("/images/sales-intelligence/find-leads-bg.svg");

export const SI_WIZARD_BACKGROUND_URL = AssetsService.assetUrl("/images/sales-intelligence/wizard-bg.svg");
export const ONBOARDING_HUB_BUTTON_URL = AssetsService.assetUrl("/images/sales-intelligence/onboarding-hub-button.svg");
export const SIWizardSmallLogoUrl = AssetsService.assetUrl("/images/sales-intelligence/si-small-logo.svg");

export const SIConnectMyCRM = AssetsService.assetUrl(`${SI_IMAGES_DIRECTORY}/connect_my_crm.png`);
export const SISetUpIntentAlertOnboardingGif = AssetsService.assetUrl(`${SI_IMAGES_DIRECTORY}/set_up_intent_alert.png`);

// gifs
export const SIHoorayOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/hooray.gif`);
export const SICompanyOverviewOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/companyoverview.gif`);
export const SIContactProfileOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/contactprofile.gif`);
export const SICrmSyncOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/crm_sync.gif`);
export const SIEnrichCsvOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/enrich_csv.gif`);
export const SIExtensionOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/extension.gif`);
export const SISetUpAlertsOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/set_up_alerts.gif`);
export const SIUploadListOfCompaniesOnboardingGif = AssetsService.assetUrl(
    `${SI_GIFS_DIRECTORY}/upload_list_of_companies.gif`,
);
export const SIFindLeadsOnboardingGif = AssetsService.assetUrl(`${SI_GIFS_DIRECTORY}/findleads.gif`);
export const SIUploadSuppressionListOnboardingGif = AssetsService.assetUrl(
    `${SI_GIFS_DIRECTORY}/upload_suppression_list.gif`,
);
